var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"available-only-in-store",class:_vm.getBemModifiers()},[_vm._v("\n    Produkt dostępny wyłącznie w sprzedaży stacjonarnej\n")])}
var staticRenderFns = []

export { render, staticRenderFns }